import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

type Color = "primary" | "secondary";

interface OrSeparatorProps {
    color?: Color;
}

const LoginSeparator = styled.div<OrSeparatorProps>`
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 16px;

    * {
        color: var(--color-primary-fg);

        ${({ color }) =>
            color === "secondary" &&
            `
                border-color: var(--color-grey-800);
                color: var(--color-grey-800);
            `}
    }
`;

const LoginSep = styled.span`
    width: 42.5%;
    height: 0;
    opacity: 0.8;
    border-bottom: 1px solid;
`;

const OrLabel = styled.p`
    width: 15%;
    font-size: var(--size-12);
    font-style: normal;
    font-weight: normal;
    line-height: 16px;
    opacity: 0.8;
    text-align: center;
`;

const OrSeparator: FC<OrSeparatorProps> = ({ color = "primary" }) => {
    const { t } = useTranslation();

    return (
        <LoginSeparator color={color}>
            <LoginSep />
            <OrLabel>{t("ItsMe.Or")}</OrLabel>
            <LoginSep />
        </LoginSeparator>
    );
};

export default OrSeparator;
